import { useTranslation } from "react-i18next";

// Assets
import addIcon from "../../assets/add_icon.png";

// Components
import CustomInput from "../../components/CustomInput";
import CustomInputWithUnit from "../../components/CustomInputWithUnit";
import CustomButton from "../../components/CustomButton";
import DashboardSection from "../../components/DasboardSection";
import deleteIcon from "../../assets/delete_Icon.png";

const PaperDataEntryModal = ({
  currentGroupCode,
  setCurrentGroupCode,
  setCurrentGroupDesign,
  currentGroupDesign,
  colorInputs,
  setColorInputs,
  onSizeDelete,
  isEditMode,
}) => {
  const { t } = useTranslation("general");

  const handleAddColorField = () => {
    setColorInputs([
      ...colorInputs,
      { colorCode: "", colorName: "", createdAt: new Date() },
    ]);
  };

  const handleColorInputChange = (index, field, value) => {
    const updated = [...colorInputs];
    updated[index][field] = value;
    setColorInputs(updated);
  };

  const handleEnter = (e, index) => {
    if (e.key === "Enter" && index === colorInputs.length - 1) {
      e.preventDefault();
      handleAddColorField();
    }
  };

  return (
    <>
      <div className="c-form-section">
        <label>{t("uniformName")}</label>
        <CustomInput
          type="text"
          value={currentGroupCode}
          onChange={(e) => setCurrentGroupCode(e.target.value)}
        />
      </div>

      <div className="c-form-section">
        <label>{t("color")}</label>
        <CustomInput
          type="text"
          value={currentGroupDesign}
          onChange={(e) => setCurrentGroupDesign(e.target.value)}
        />
      </div>

      <div className="o-column o-column--gap-size_300 u-margin--top_300">
        <h3 className="u-margin_0">{t("sizes")}</h3>
        {colorInputs.map((color, index) => (
          <DashboardSection
            title={`${t("size")} ${index + 1}`}
            classList="u-margin_0"
            key={index}
          >
            <div key={index} className="o-column o-column--gap-size_400">
              <div className="o-row u-width_full-width o-row--gap-size_500 o-column-row-switcher">
                <CustomInput
                  title={t("size")}
                  placeholder={t("size")}
                  value={color.size}
                  onChange={(e) =>
                    handleColorInputChange(index, "size", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  flex
                />
                <CustomInputWithUnit
                  title={t("theCount")}
                  placeholder={t("theCount")}
                  value={color.quantity}
                  onChange={(e) =>
                    handleColorInputChange(index, "quantity", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  unit={t("piece")}
                  flex
                />
              </div>
              <div className="o-row u-width_full-width o-row--gap-size_500 o-column-row-switcher">
                <CustomInputWithUnit
                  title={t("singlePurchasePrice")}
                  placeholder={t("price")}
                  value={color.purchasePrice}
                  onChange={(e) =>
                    handleColorInputChange(index, "purchasePrice", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  unit={"IQD"}
                  flex
                />

                <CustomInputWithUnit
                  title={t("singleSellPrice")}
                  placeholder={t("price")}
                  value={color.sellPrice}
                  onChange={(e) =>
                    handleColorInputChange(index, "sellPrice", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  unit={"IQD"}
                  flex
                />
              </div>

              <div className="o-row u-width_full-width o-row--gap-size_400">
                <CustomInput
                  type="textarea"
                  title={t("notes")}
                  placeholder={t("notes")}
                  value={color.notes}
                  onChange={(e) =>
                    handleColorInputChange(index, "notes", e.target.value)
                  }
                  onKeyDown={(e) => handleEnter(e, index)}
                  flex
                />
              </div>
            </div>

            {colorInputs.length > 1 && (
              <div className="o-row o-row--horizontal-align_end">
                <CustomButton
                  title={`${t("deleteSize")} ${index + 1}`}
                  variant="red"
                  onClick={() => {
                    if (color.id) {
                      onSizeDelete?.(color.id);
                      return;
                    }
                    setColorInputs((prev) =>
                      prev.filter((_, i) => i !== index),
                    );
                  }}
                  icon={deleteIcon}
                  iconSize={16}
                />
              </div>
            )}
          </DashboardSection>
        ))}

        <div className="o-row o-row--horizontal-align_end u-margin--top_500">
          <CustomButton
            variant={"blank"}
            onClick={handleAddColorField}
            title={t("addAnotherSize")}
            icon={addIcon}
            iconSize={16}
          />
        </div>
      </div>
    </>
  );
};

export default PaperDataEntryModal;
